import { useState } from "react";

import useSelectedMinerAccount from "../../../hooks/useSelectedMinerAccount";
import LinkedInAccountFormField from "../LinkedInAccountFormField";
import ScrollAndFooter from "../ScrollAndFooter";
import GroupFormField from "./GroupFormField";
import SelectedGroup from "./SelectedGroup";

import type {
  GroupLeadListSource,
  LinkedInGroup as GroupType,
} from "../../../types";

import GroupImage from "assets/images/sources/group.png";

interface GroupProps {
  createSource: (params: {
    miner: string;
    settings: GroupLeadListSource["settings"];
  }) => void;
  isCreatingSource: boolean;
}

export default function Group({ createSource, isCreatingSource }: GroupProps) {
  const { setMinerAccountId, minerAccountId } = useSelectedMinerAccount();
  const [selectedGroup, setSelectedGroup] = useState<GroupType>();

  return (
    <ScrollAndFooter
      leadCount={selectedGroup ? selectedGroup.member_count : 0}
      isCreatingSource={isCreatingSource}
      onCreate={() =>
        createSource({
          miner: minerAccountId,
          settings: { type: "group", group_id: selectedGroup.id },
        })
      }
    >
      <div className="flex flex-col gap-y-3 lg:gap-y-6 max-w-135 m-auto">
        <div className="flex gap-3 lg:gap-5 max-lg:order-3 flex-col lg:flex-row">
          <LinkedInAccountFormField
            accountId={minerAccountId}
            setAccountId={setMinerAccountId}
          />
          <GroupFormField
            accountId={minerAccountId}
            selectedGroup={selectedGroup}
            onSelect={setSelectedGroup}
          />
        </div>

        {selectedGroup ? (
          <SelectedGroup group={selectedGroup} />
        ) : (
          <img src={GroupImage} alt="" height={238} />
        )}
      </div>
    </ScrollAndFooter>
  );
}
